import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { reportSynthesisRequested } from '../Entities/actions';

function useLegacyOrdersExport() {
  const dispatch = useDispatch();

  const requestReportSynthesis = useCallback(() => {
    dispatch(reportSynthesisRequested());
  }, [dispatch]);

  return {
    error: undefined,
    isLoading: false,
    requestReportSynthesis,
  };
}

export default useLegacyOrdersExport;
